export async function urlToFile(name: string, url: string, type: string, extension: string) {
  const response = await fetch(url);
  const data = await response.blob();
  const metadata = {
    type,
  };
  const file = new File([data], `${name}.${extension}`, metadata);
  return file;
}
